import React from 'react';
import './InfoBlocks.css';
import { FaShieldAlt, FaDiscord, FaShoppingCart } from 'react-icons/fa';
import { RiGitRepositoryPrivateFill } from "react-icons/ri";
import { VscCompassActive } from "react-icons/vsc";
import { GiWingfoot } from "react-icons/gi";
import { GiAk47 } from "react-icons/gi";
import { HiOutlineSquaresPlus } from "react-icons/hi2";
import { BsNvidia } from "react-icons/bs";
import { RiTestTubeLine } from "react-icons/ri";

const InfoBlocks = () => {
  return (
    <div className="info-blocks-wrapper">
     <h2 className="info-blocks-heading">Features</h2>
        <p className="features-header-text">We offer a wide range of premium features for our Rust script</p>

      {/* Erste Zeile mit drei Blöcken */}
      <div className="info-blocks-container">
        <div className="info-block">
          <h3>
            <FaShieldAlt className="info-icon" /> Undetected
          </h3>
          <p>
            EAGLE Scripts is 100% safe to use. All settings are saved in the cloud. No interaction with any game processes.
          </p>
        </div>
        <div className="info-block">
          <h3>
            <RiGitRepositoryPrivateFill className="info-icon" /> Private Builds
          </h3>
          <p>
            Each user receives a complete unique and private build of the script. Every build is individually encrypted.
          </p>
        </div>
        <div className="info-block">
          <h3>
            <HiOutlineSquaresPlus className="info-icon" /> Hotkeys
          </h3>
          <p>
            Create your own custom hotkeys and automatically save them in our cloud. The script is fully customizable.
          </p>
        </div>
      </div>

      {/* Zweite Zeile mit drei Blöcken */}
      <div className="info-blocks-container second-row">
        <div className="info-block">
          <h3>
            <GiAk47 className="info-icon" /> All Weapons
          </h3>
          <p>
            All weapons & attachments are supported. The script is designed to work with all weapons in Rust - even minigun!
          </p>
        </div>
        <div className="info-block">
          <h3>
            <FaDiscord className="info-icon" /> Discord Support
          </h3>
          <p>
            We offer free support for all active users in our Discord server. Join us for help, updates, and community discussions.
          </p>
        </div>
        <div className="info-block">
          <h3>
            <GiWingfoot className="info-icon" /> Anti-AFK
          </h3>
          <p>
            Activate the Anti-AFK feature to prevent being kicked out of the game. This feature keeps you active in Rust server with queue.
          </p>
        </div>
      </div>

      {/* Dritte Zeile mit drei Blöcken */}
      <div className="info-blocks-container second-row">
        <div className="info-block">
          <h3>
            <VscCompassActive className="info-icon" /> Active Development
          </h3>
          <p>
            The script is under active development with regular updates. We are constantly adding new features and improving existing ones.
          </p>
        </div>
        <div className="info-block">
          <h3>
            <BsNvidia className="info-icon" /> Cloud Gaming
          </h3>
          <p>
            Our Rust script supports cloud gaming platforms like GeForce Now, Shadow, and more. Play Rust with our script on any device.
          </p>
        </div>
        <div className="info-block">
          {/* Coming Soon-Tag jetzt separat, oben rechts */}
          <span className="info-tag">Coming Soon</span>
          <h3>
            <RiTestTubeLine className="info-icon" /> Auto Detection
          </h3>
          <p>
            We are currently testing weapon & attachment auto detection in a beta version. This feature will be available soon for all users.
          </p>
        </div>
      </div>
      
      {/* Purchase-Button */}
      <div className="purchase-button-container">
        <button className="purchase-button"
          onClick={() => {
            window.location.href = "#pricing";
          }}
        >
          <FaShoppingCart className="purchase-icon" />
          <span>Purchase to Download</span>
        </button>
      </div>
    </div>
  );
};

export default InfoBlocks;
